const angular = require('angular');

const { pickupAddressSearchComponentDefinition } = require('./pickup-address-search.component');
const { pickupAddressListComponentDefinition } = require('./pickup-address-list.component');
const { pickupAddressComponentDefinition } = require('./pickup-address.component');
const { savedAddressesComponentDefinition } = require('./saved-addresses.component');
const { manualAddressComponentDefinition } = require('./manual-address.component');
const { addressEntryFormComponentDefinition } = require('./address-entry-form.component');
const AddressServiceDefinition = require('./address.service');

angular.module('wowApp.fulfilment')
    .constant('AddressEntryModes', {
        manual: 'MANUAL',
        search: 'SEARCH',
    })
    .service('AddressService', AddressServiceDefinition)
    .service('PickupAddressSearchService', ['Restangular', 'StoreService', require('./pickup-address-search.service')])
    .factory('StateService', ['$rootScope', 'Restangular', require('./state.service')])
    .component('wowPickupAddressSearch', pickupAddressSearchComponentDefinition)
    .component('wowPickupAddressList', pickupAddressListComponentDefinition)
    .component('wowPickupAddress', pickupAddressComponentDefinition)
    .component('wowSavedAddresses', savedAddressesComponentDefinition)
    .component('wowManualAddress', manualAddressComponentDefinition)
    .component('wowAddressEntryForm', addressEntryFormComponentDefinition);



// WEBPACK FOOTER //
// ./src/fulfilment/address/index.js